import React, {useEffect} from "react";
import ReactGA from "react-ga";

export const SorryView = () => {
    useEffect(() => {
        ReactGA.set({page: "/con/sorry"});
        ReactGA.pageview("/con/sorry");
    }, []);
    return (
        <div className="AppViews--view">
            <div className="AppViews--simple">
                <p>
                    Sorry. You seem to already have the gallery open.
                </p>
                <p>
                    If you just reloaded the page, try again in a few seconds.
                </p>
            </div>
        </div>
    );
};
